import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { PagesRoutingModule } from './pages-routing.module';
import { FormCommunityComponent } from './form-community/form-community.component';
import { ComponentsModule } from '../components/components.module';
import { MaterialModule } from '../shared/material/material.module';
import { AdministratorService } from '../core/servicie/administrador.service';
import { CustomerService } from '../core/servicie/customer.service';
import { MatIconModule } from '@angular/material/icon';
import { HomeComponent } from './home/home.component';
import { AboutTheTitanAppComponent } from './about-the-titan-app/about-the-titan-app.component';
import { LearnToUseTheTitanAppComponent } from './learn-to-use-the-titan-app/learn-to-use-the-titan-app.component';
import { TrustworthyTitansComponent } from './trustworthy-titans/trustworthy-titans.component';
import { TitanInformationComponent } from './titan-information/titan-information.component';


@NgModule({
  declarations: [
    FormCommunityComponent,
    HomeComponent,
    AboutTheTitanAppComponent,
    LearnToUseTheTitanAppComponent,
    TrustworthyTitansComponent,
    TitanInformationComponent,

  ],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    PagesRoutingModule,
    ComponentsModule,
    MaterialModule,
    MatIconModule
  ],
  providers:[AdministratorService,CustomerService ]
})
export class PageModule {}
